export default "__VITE_ASSET__Cl_hX1O4__"